import * as React from "react"
import { Link } from "gatsby"
import { BannerModuleStyles } from "./BannerModuleStyles"
import { StaticImage } from "gatsby-plugin-image"
import Button from "../Button/Button"
import Reveal from "../Reveal/Reveal"
import ShaderBackground from "../ShaderBackground/ShaderBackground"

const BannerModule = ({
  children,
  eyebrow,
  title,
  subTitle,
  price,
  ctaText,
  ctaTo,
}) => {
  const handleClickScroll = () => {
    const element = document.getElementById("content-section")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <>
      <BannerModuleStyles>
        {children ? (
          children
        ) : (
          <StaticImage
            className="banner__image"
            imgClassName="banner__image--content"
            src="../../../static/macbook-color.jpg"
            alt="Banner Image"
            layout="fullWidth"
            placeholder="blurred"
          />
        )}
        {/* subtle living amber light over the image */}
        <ShaderBackground className="banner__shader" speed={0.03} />

        <div className="container">
          <div className="banner__content">
            {eyebrow && (
              <Reveal>
                <p className="eyebrow">{eyebrow}</p>
              </Reveal>
            )}
            {title && (
              <Reveal delay={0.08}>
                <h1>
                  {title}
                  <span style={{ color: "var(--color-gold-500)" }}>.</span>
                </h1>
              </Reveal>
            )}
            {subTitle && (
              <Reveal delay={0.16}>
                <p className="banner__lead">{subTitle}</p>
              </Reveal>
            )}
            {price && (
              <Reveal delay={0.2}>
                <h2 className="price">
                  £{price}
                  <span style={{ color: "var(--color-gold-500)" }}>.</span>
                </h2>
              </Reveal>
            )}
            <Reveal delay={0.26}>
              <div className="banner__btns">
                {ctaText && ctaTo && (
                  <Button as={Link} to={ctaTo} text={ctaText} arrow />
                )}
                <Button
                  onClick={handleClickScroll}
                  text="Learn More"
                  arrow
                  ghost
                />
              </div>
            </Reveal>
          </div>
        </div>
        <div className="gradient"></div>
      </BannerModuleStyles>
      <span id="topContent"></span>
    </>
  )
}

export default BannerModule
